import { render, staticRenderFns } from "./BaleWovenDetailRow.vue?vue&type=template&id=9321f9d2&scoped=true"
import script from "./BaleWovenDetailRow.vue?vue&type=script&lang=js"
export * from "./BaleWovenDetailRow.vue?vue&type=script&lang=js"
import style0 from "./BaleWovenDetailRow.vue?vue&type=style&index=0&id=9321f9d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9321f9d2",
  null
  
)

export default component.exports